module.exports = __webpack_public_path__ + "img/2.6996ab53.jpg";